import { DEFAULT_TEAM_IMPLEMENTATION_SETTINGS } from "src/components";
import { useSettings, type ITeamImplementationSettings } from "src/hooks";

const useTeamImplementationSettings = (teamSlug: string) => {
  const {
    teamImplementationSettings: { [teamSlug]: unsafeSettings },
    updateTeamImplementationSettings,
  } = useSettings();

  const safeSettings: ITeamImplementationSettings = {
    ...DEFAULT_TEAM_IMPLEMENTATION_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<ITeamImplementationSettings>) => {
      updateTeamImplementationSettings(teamSlug, updatedSettings);
    },
  };
};

export { useTeamImplementationSettings };
